import { defineMessages } from 'react-intl';

export const classDetailMessages = defineMessages({
  classes: {
    id: 'class-detail.classes',
    defaultMessage: 'Classes',
  },
  noClasses: {
    id: 'class-detail.no-classes',
    defaultMessage: 'You have no classes associated with this venue',
  },
  class: {
    id: 'class-detail.class',
    defaultMessage: 'Class',
  },
  publish: {
    id: 'class-detail.publish',
    defaultMessage: 'Save',
  },
  editDescription: {
    id: 'class-detail.edit-description',
    defaultMessage: 'Class description',
  },
  editExplanation: {
    id: 'class-detail.edit-explanation',
    defaultMessage: 'Be specific and detailed about your class so members know why they should book.',
  },
  editClassTitle: {
    id: 'class-detail.edit-class-title',
    defaultMessage: 'Class name',
  },
  seeExample: {
    id: 'class-detail.see-example',
    defaultMessage: 'See Examples',
  },
  charactersRemaining: {
    id: 'class-detail.characters-remaining',
    defaultMessage: '{remaining, plural, one {# character} other {# characters}} remaining',
  },
  whatToBringTitle: {
    id: 'class-detail.what-to-bring-title',
    defaultMessage: 'How to prepare',
  },
  whatToBringExplanation: {
    id: 'class-detail.what-to-bring-explanation',
    defaultMessage:
      'Include what to bring, what to wear, and anything else a client should know before coming to class. Members will receive an email with this information after they make a reservation.',
  },
  classLocationTitle: {
    id: 'class-detail.class-location.title',
    defaultMessage: 'Class Location',
  },
  locationTypeVenue: {
    id: 'class-detail.location-type.venue',
    defaultMessage: 'At my business address',
  },
  locationTypeOutdoor: {
    id: 'class-detail.location-type.outdoor',
    defaultMessage: 'Outdoors',
  },
  howToGetThereTitle: {
    id: 'class-detail.how-to-get-there.title',
    defaultMessage: 'How to get there',
  },
  howToGetThereDescription: {
    id: 'class-detail.how-to-get-there.description',
    defaultMessage: 'Any additional helpful notes on how to find the class',
  },
  latlngTitle: {
    id: 'class-detail.lat-lng.title',
    defaultMessage: 'Set pin for exact class location',
  },
  reservations: {
    id: 'class-detail.reservations',
    defaultMessage: 'Reservations',
  },
  enabled: {
    id: 'class-detail.enabled',
    defaultMessage: 'Enabled',
  },
  disabled: {
    id: 'class-detail.disabled',
    defaultMessage: 'Disabled',
  },
  required: {
    id: 'class-detail.required',
    defaultMessage: 'Required',
  },
});

export const validatorMessages = defineMessages({
  descriptionRequired: {
    id: 'class-detail.errors.description-required',
    defaultMessage: 'Class description is required',
  },
  minLengthDescription: {
    id: 'class-detail.errors.description-less-than',
    defaultMessage: 'Class description must be less than {limit, number} characters',
  },
  titleRequired: {
    id: 'class-detail.errors.title-required',
    defaultMessage: 'Class name is required',
  },
  activityRequired: {
    id: 'class-detail.errors.activity-required',
    defaultMessage: 'Please choose an activity type',
  },
  categoryRequired: {
    id: 'class-detail.errors.category-required',
    defaultMessage: 'Please choose a category',
  },
});

export const networkSpotsSectionMessages = defineMessages({
  availabilityTitle: {
    id: 'class-detail.availability-title',
    defaultMessage: 'Availability on ClassPass',
  },
  networkSpots: {
    id: 'class-detail.network-spots',
    defaultMessage: 'Default Spots',
  },
});

export const freeClassMessages = defineMessages({
  title: {
    id: 'class-detail.free-class.title',
    defaultMessage: 'Free class',
  },
  cta: {
    id: 'class-detail.free-class.cta',
    defaultMessage: 'Set as free class',
  },
  description: {
    id: 'class-detail.free-class.description',
    defaultMessage:
      'ClassPass members will see your class offered for 0 credits and you will receive $0 payout for free class reservations. This action is {irreversibleExplainer}',
  },
  irreversibleExplainer: {
    id: 'class-detail.free-class.irreversible-explainer',
    defaultMessage: 'irreversible; you can’t undo it.',
  },
  noteFutureFree: {
    id: 'class-detail.free-class.note-future-free',
    defaultMessage:
      'Note: This will apply to all current and future schedules of this class. If you only wish to make a single instance free, do not use this option.',
  },
  terms: {
    id: 'class-detail.free-class.terms',
    defaultMessage:
      'By enabling this option you agree to the above, and to the ClassPass <termslink>Terms</termslink>, on behalf of the entity that is party to your Partner Agreement, and you represent and warrant that you have the right, power, and authority to do so.',
  },
  note: {
    id: 'class-detail.free-class.note',
    defaultMessage:
      'Please note that this offer is not the same as First Class Free (a/k/a the ClassPass Trialer Program).  By activating this offer, you agree to permanently offer this class to users for free and accept $0 payment by ClassPass.',
  },
  confirmationTitle: {
    id: 'class-detail.free-class.confirmation-title',
    defaultMessage: 'You will not receive payments for this class!',
  },
  confirmationSubtitle: {
    id: 'class-detail.free-class.confirmation-subtitle',
    defaultMessage:
      'This action is {irreversibleExplainer} This update will make all current and future schedules of this class FREE. Do you want to make this class free for ClassPass members?',
  },
  setFreeSuccess: {
    id: 'class-detail.free-class.free-success',
    defaultMessage: 'Class set free successfully!',
  },
  setFreeError: {
    id: 'class-detail.free-class.free-error',
    defaultMessage: 'An error occured while attempting to set class as free.',
  },
  freeClassDesc: {
    id: 'class-detail.free-class.free-class',
    defaultMessage:
      'ClassPass members will see your class offered for 0 credits and you will receive $0 payout for free class reservations.',
  },
  yes: {
    id: 'class-detail.free-class.yes',
    defaultMessage: 'Irreversibly make it free',
  },
});
